import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '../cx.js';

export interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Riga sotto il titolo: spiega cosa succede dopo. */
  description?: ReactNode;
  children?: ReactNode;
  /** Bottoni in fondo: al massimo un primario. */
  actions?: ReactNode;
  testoChiudi?: string;
  className?: string;
}

/** Finestra modale accessibile (Radix): focus intrappolato, Esc chiude, titolo annunciato. */
export function Dialog({ open, onOpenChange, title, description, children, actions, testoChiudi = 'Chiudi', className }: DialogProps) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-40 bg-ink/40" />
        <RadixDialog.Content
          className={cx(
            'fixed z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-2*var(--space-6))] max-w-[520px]',
            'bg-surface rounded-lg shadow-overlay p-6 flex flex-col gap-4 focus:outline-none max-h-[90dvh] overflow-y-auto',
            className,
          )}
        >
          <div className="flex items-start justify-between gap-4">
            <RadixDialog.Title className="t-title-2">{title}</RadixDialog.Title>
            <RadixDialog.Close
              aria-label={testoChiudi}
              className="h-11 w-11 -mr-2 -mt-2 shrink-0 inline-flex items-center justify-center rounded-md text-ink-muted hover:text-ink hover:bg-surface-sunken"
            >
              <X aria-hidden size={20} strokeWidth={1.75} />
            </RadixDialog.Close>
          </div>
          {description && <RadixDialog.Description className="t-body text-ink-muted">{description}</RadixDialog.Description>}
          {children}
          {actions && <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-2">{actions}</div>}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
